import React, { Component } from 'react'
import { TableLegend, DataTableHeaderSearch } from 'src/components'
import './dataTableHeader.scss'

class DataTableHeader extends Component {
    render() {
        const { title, statusMap, handleSearchChange } = this.props
        return (
            <div className="datatable-header">
                <div className="datatable-title-legend">
                    <h1 className="content-title">{title}</h1>
                    <TableLegend statusMap={statusMap} />
                </div>
                <div className="datatable-search-input">
                    <DataTableHeaderSearch
                        handleSearchChange={handleSearchChange}
                    />
                </div>
            </div>
        )
    }
}

export default DataTableHeader
